import type { Type } from '@angular/core';
import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { from, shareReplay, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import type { IntegrationsElement } from '@recruitee/integrations-types';

import { ELEMENT_MAPPING } from '../../integrations/elements';

export interface IntegrationsElementWithComponent extends IntegrationsElement {
  componentClass: Type<any>;
}

@Injectable({ providedIn: 'root' })
export class IntegrationsElementsService {
  private elementMap = new Map(
    ELEMENT_MAPPING.map(([k, v]) => [k, () => from(v()).pipe(shareReplay())]),
  );

  public resolveComponents(
    elements: IntegrationsElement[],
  ): Observable<IntegrationsElementWithComponent[]> {
    return zip(elements.map(({ component }) => this.getComponentClass(component)())).pipe(
      map(components =>
        elements.map((element, i) => ({ ...element, componentClass: components[i] })),
      ),
    );
  }

  private throwNoMatchingElementError(tagName: string): Error {
    throw new Error(`${tagName} not found in ElementsModule.elementsOutletMapping`);
  }

  private getComponentClass(tagName: string): () => Observable<Type<any>> {
    if (!this.elementMap.has(tagName)) this.throwNoMatchingElementError(tagName);

    return this.elementMap.get(tagName)!;
  }
}
